export enum NicheTab {
  active = "active",
  all = "all",
}

export enum SelectedSetting {
  niche = "niche",
  general = "general",
  onboarding = "onboarding",
  payInfo = "payInfo",
  preferences = "preferences",
  emailWarmup = "emailWarmup",
  help = "help",
}
